import React from "react";
import {
  Header,
  useTheme,
  useMediaQuery,
  breakpoints
} from "@tvg/design-system";
import { Container, TitleContainer } from "./styled-components";
import { Props } from "./types";
import EmptyCase from "./EmptyCase";
import CurrentProbable from "./CurrentProbable";
import { WAGER_ID_FILTER } from "./constants";

const Probables = React.forwardRef<HTMLDivElement, Props>(
  ({ currentRace, nextRace }, ref) => {
    const { colors } = useTheme();
    const probables =
      currentRace.probables
        ?.filter((item) => item.wagerType.id > WAGER_ID_FILTER) // Filtering probables with wager types ids above 30 to match MEP
        .sort((a, b) => (a.wagerType.id > b.wagerType.id ? 1 : -1)) || []; // We order the probables by id from lowest to highest
    const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

    return (
      <Container
        ref={ref}
        data-qa-label="probables"
        isEmptyMessage={!probables.length}
      >
        {probables.length > 0 ? (
          <>
            {!isMobile && (
              <TitleContainer
                data-qa-label="probables-header-container"
                colors={colors}
              >
                <Header
                  tag="h3"
                  fontWeight={700}
                  qaLabel="probables-header-text"
                >
                  Probables
                </Header>
              </TitleContainer>
            )}
            <CurrentProbable
              probables={probables}
              currentRace={currentRace}
              nextRace={nextRace}
            />
          </>
        ) : (
          <EmptyCase />
        )}
      </Container>
    );
  }
);

export default Probables;
